import React from "react";
import ReactDOM from "react-dom";
import { ModalWrapper, ModalContainer, CloseButton } from "./CustomModalStyles";

const CustomModal = ({ isOpen, onClose, children, testid, showCloseButton = true, maxWidth }) => {
  if (!isOpen) {
    return null;
  }

  const modalContent = (
    <ModalWrapper testid={testid}>
      <ModalContainer maxWidth={maxWidth}>
        {showCloseButton && <CloseButton onClick={onClose}>&times;</CloseButton>}
        {children}
      </ModalContainer>
    </ModalWrapper>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default CustomModal;
